import { Checkbox, FormControlLabel, Grid } from "@mui/material";
import React from "react";

interface Props {
  handleUpdateParent: (field: "costSchema" | "paySchema" | "sectionsWithZeroAmount", value: boolean) => void;
  paySchema: boolean;
  costSchema: boolean;
  sectionsWithZeroAmount: boolean;
}

const PickExportSendBlocks = ({ handleUpdateParent, paySchema, costSchema, sectionsWithZeroAmount }: Props) => {
  return (
    <Grid style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
      <FormControlLabel
        label="Include cost schema"
        control={
          <Checkbox
            checked={costSchema}
            onChange={(_, checked) => handleUpdateParent("costSchema", checked)}
          />
        }
      />
      <FormControlLabel
        label="Include pay schema"
        control={
          <Checkbox
            checked={paySchema}
            onChange={(_, checked) => handleUpdateParent("paySchema", checked)}
          />
        }
      />
      <FormControlLabel
        label="Include sections with zero amounts"
        control={
          <Checkbox
            checked={sectionsWithZeroAmount}
            onChange={(_, checked) => handleUpdateParent("sectionsWithZeroAmount", checked)}
          />
        }
      />
    </Grid>
  );
};
export default PickExportSendBlocks;
